import { BasicEntity } from "../../../core/models/basic-entity";

export class DocumentStatus extends BasicEntity {
    public Color?: string;
    public Sequence?: number;
}
